import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, Icon, Link, Stack, Type } from 'react-spark';
import config from '../../../../config';
import { getAppUrl } from '../../../../utils/url';

class OffersV2HelpCard extends Component {
    static propTypes = {
        icon: PropTypes.node.isRequired,
        label: PropTypes.node.isRequired,
        content: PropTypes.node.isRequired,
    };

    render() {
        const { icon, label, content } = this.props;

        return (
            <Card
                className="sprk-u-MaxWidth--none sprk-u-BackgroundColor--white sprk-u-BorderSolid
                    sprk-u-BorderColor--black-tint-25 sprk-u-pam"
                style={{ borderWidth: '1px' }}>
                <Stack className="sprk-u-Flex--row sprk-o-Stack--center-column sprk-u-pas">
                    <Stack.Item className="sprk-u-prm">
                        {icon}
                    </Stack.Item>
                    <Stack.Item>
                        <Type.BodyTwo className="sprk-u-TextTransform--uppercase antialiased sprk-u-pbs sprk-u-man">
                            {label}
                        </Type.BodyTwo>
                        <Type.BodyFour className="sprk-u-man">
                            {content}
                        </Type.BodyFour>
                    </Stack.Item>
                </Stack>
            </Card>
        );
    }
}

const { phone, email } = config.global.company;

export class OffersV2Help extends Component {
    render() {
        return (
            <Stack className="sprk-u-pvl sprk-u-Flex--col sprk-u-Flex--row@m" style={{ gap: '32px'}}>
                <Stack.Item style={{ flex: 1 }}>
                    <Type.DisplayFive id="need-some-help">
                        Need Some Help?
                    </Type.DisplayFive>
                    <Type.BodyTwo>
                        You can find more information on our{' '}
                        <Link href={getAppUrl('faq')} target="_blank" variant="inline">
                            FAQ Page
                        </Link>.{' '}
                        You can also contact our customer service team.
                    </Type.BodyTwo>
                </Stack.Item>

                <Stack.Item style={{ flex: 2 }}>
                    <Stack className='sprk-u-Flex--col sprk-u-Flex--row@s sprk-u-ptm@m' style={{ gap: '32px'}}>
                        <Stack.Item style={{ flex: 1 }}>
                            <OffersV2HelpCard
                                icon={<Icon name="landline" />}
                                content={(
                                    <a className="sprk-u-Color--inherit" href={`tel:${phone.dash}`}>
                                        {phone.long}
                                    </a>
                                )}
                                label={'Phone'} />
                        </Stack.Item>
                        <Stack.Item style={{ flex: 1 }}>
                            <OffersV2HelpCard
                                icon={<Icon name="email" />}
                                content={(
                                    <a className="sprk-u-Color--inherit" href={`mailto:${email.support}`}>
                                        {email.support}
                                    </a>
                                )}
                                label={'Email'} />
                        </Stack.Item>
                    </Stack>
                </Stack.Item>
            </Stack>
        );
    }
}
